import React, { useEffect, useReducer, useState } from "react";
import CookieConsent from "./components/CookieConsent";
import { getCookieConsent } from "./utils";

function reducer(state, action) {
  if (action?.type === "show") {
    return true;
  }
  return !state;
}

export default function Root() {
  const [isUS, setIsUS] = useState<boolean>();
  const [showMessage, toggleMessage] = useReducer(
    reducer,
    getCookieConsent() === undefined
  );
  useEffect(() => {
    fetch("https://static.matterport.com/geoip/")
      .then((res) => res.json())
      .then((res) => {
        if (res.country_code === "US") {
          const cookie = getCookieConsent();
          setIsUS(true);
          if (cookie?.usChecked === undefined) {
            toggleMessage({
              type: "show",
            });
          }
        } else {
          setIsUS(false);
        }
      })
      .catch((e) => {
        console.error(e);
        setIsUS(false);
      });
  }, []);
  return (
    <>
      {showMessage && isUS !== undefined && (
        <CookieConsent onClose={toggleMessage} isUS={isUS} />
      )}
    </>
  );
}
